import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { TechnicianService } from '../../../services/technician.service';

@Component({
  selector: 'app-technician-picker',
  templateUrl: './technician-picker.component.html',
  styleUrls: ['./technician-picker.component.scss']
})
export class TechnicianPickerComponent implements OnInit {
  @Output() onTechnicianSet = new EventEmitter<any>();
  @Input() _placeholder: string = 'Please Select';
  @Input() technicianId: number;
  @Input() getAll: boolean = false;
  technicians = [];

  constructor(private technicianService: TechnicianService) {
  }

  ngOnInit(): void {

    if (this.getAll) {
      this.technicianService.getAll().then((technicians) => {
        this.technicians = technicians;

        if (this.technicianId != null)
          this.technicianChanged();
      });
   } else {
     this.technicianService.getActive().then((technicians) => {
       this.technicians = technicians;

       if (this.technicianId != null)
         this.technicianChanged();
     });
    }
  
  }


  technicianChanged() {
    var technician = this.technicians.find(a => a.id == this.technicianId);
    this.onTechnicianSet.emit(technician);
  }

}
